import { type DataLayerCallbackProps } from '@dhl/datalayer'
import { type DataLayerData, type DataLayerEvent, type DataLayerMeta } from '../types/types.js'
import { type AdobeContentEvent } from './types.js'
import { getDefaultMetaAttributes } from './getDefaultMetaAttributes.js'

export const writeContentEvent = (dataLayerEvent: DataLayerCallbackProps<DataLayerData, DataLayerMeta>): void => {
  const { name, type, attributes, context, interaction, position, validations } = dataLayerEvent.meta as DataLayerEvent
  const data: AdobeContentEvent = {
    event: 'dhl_utf_contentInteraction',
    content: {
      name,
      type,
      context,
      interaction,
      position,
      validations,
      attributes: {
        ...getDefaultMetaAttributes(dataLayerEvent.data),
        ...attributes,
      },
    },
  }
  window.dataLayer?.push(data)
}
